window.getCurrencySymbol = () => '$';

window.formatPrize = price => `${window.getCurrencySymbol()}${price.toLocaleString()}`;